import { Reveal } from "@/components/Reveal";

const CHAPTERS = [
  {
    num: "01",
    title: "The 18-Minute Standard",
    body: "Most of Tarrant County sits inside our rapid-response radius. When you call or text, a truck is rolling — not being assigned, not being quoted. Rolling.",
  },
  {
    num: "02",
    title: "Zero Hidden Surcharges",
    body: "The price we quote on the phone is the price you pay at the curb. No after-hours games, no mileage surprises, no fine print.",
  },
  {
    num: "03",
    title: "Damage-Free Guarantee",
    body: "Wheel-lift, dollies, and careful rigging on every job. Your vehicle arrives exactly the way we found it — that's the whole point.",
  },
];

const Manifesto = () => (
  <section className="relative bg-asphalt py-20 sm:py-32 grain" data-testid="manifesto-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6">
      <Reveal>
        <p className="font-mono text-xs tracking-[0.3em] text-emergency uppercase mb-4">The Paliway Standard</p>
      </Reveal>
      <div className="divide-y divide-white/10 border-y border-white/10">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.num} delay={i * 0.08}>
            <div className="group grid gap-4 py-10 sm:py-14 md:grid-cols-[140px_1fr_1.2fr] md:gap-10 items-baseline">
              <span className="font-mono text-sm font-bold text-emergency">[{c.num}]</span>
              <h3 className="font-display text-2xl sm:text-3xl lg:text-4xl font-black uppercase leading-none text-white transition-colors duration-300 group-hover:text-emergency">
                {c.title}
              </h3>
              <p className="text-base leading-relaxed text-zinc-400">{c.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Manifesto;
